import { Injectable } from '@angular/core';
import { IID_GENERIC_KO } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IID_Generic_KoQuery } from './genericKo.query';
import { IID_Generic_KoStore } from './genericKo.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.GENERIC_KO)
export class IID_Generic_KoService extends CrudService<IID_GENERIC_KO, IID_Generic_KoStore, IID_Generic_KoQuery> {
  constructor(
    protected store: IID_Generic_KoStore,
    public query: IID_Generic_KoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_GENERIC_KO,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
